export default __webpack_public_path__ + "static/media/glider1.a0b050d1.png";